<template>
  <div class="view">
    <transition name="page-switch">
      <div class="loginBox" v-if="typeLink == 1">
        <div class="login-title">
          <h1>验证码登录</h1>
          <p>登录即表示您已同意<span @click="goUrl(1)">用户协议</span>和<span @click="goUrl(2)">隐私政策</span></p>
        </div>
        <div class="input_box">
          <u-input
            type="phone"
            placeholder="请输入手机号码"
            v-model="inputvalue"
            maxlength="13"
            center
            clearable
          ></u-input>
        </div>
        <u-button class="login" type="primary" :disabled="!isGoSend" @click.native="sendCode">登录</u-button>
        <div class="switchPsw" @click="switchType(3)">密码登录</div>
      </div>
    </transition>
    <transition name="page-switch">
      <div class="loginBox" v-if="typeLink == 2" @click="focusCode">
        <div class="login-title">
          <h1>输入验证码</h1>
          <p>
            验证码已发送至 <span class="black">{{ phone }}</span>
          </p>
        </div>
        <div class="check-input">
          <ul class="num-list u-flex_row">
            <li class="num-box left" v-for="(item, index) in boxList" :key="index">
              <div class="cursor" v-if="checkNum.length === index"></div>
              <div class="num" v-if="checkNum.length >= index + 1">{{ checkNum[index] }}</div>
            </li>
          </ul>
          <u-input ref="codeInput" class="check-num" type="num" v-model="checkNum" maxlength="6"></u-input>
          <!-- <input ref="codeInput" class='check-num' type='number' v-model="checkNum" maxlength='6' pattern=[0-9]* focus='true' auto-focus='true' oninput="if(value.length > 6) value = value.slice(0, 6)"> -->
        </div>
        <div class="btn-send">
          <i v-show="countdown > 0">重新获取（{{ countdown }}s）</i>
          <span v-show="countdown == 0" @click="sendCode">重新获取</span>
        </div>

        <div class="login-go" v-if="checkNum.length == 6"><i></i></div>
      </div>
    </transition>
    <transition name="page-switch">
      <div class="loginBox" v-if="typeLink == 3">
        <div class="login-title">
          <h1>密码登录</h1>
          <p>登录即表示您已同意<span @click="goUrl(1)">用户协议</span>和<span @click="goUrl(2)">隐私政策</span></p>
        </div>
        <div class="input_box">
          <u-input
            type="phone"
            placeholder="请输入账号或手机号"
            v-model="inputvalue"
            maxlength="13"
            center
            clearable
          ></u-input>
          <u-input type="password" placeholder="请输入密码" v-model="inputpsw" center showPassword clearable></u-input>
        </div>
        <u-button class="login" type="primary" :disabled="!isLogin" @click.native="clickLogin" :loading="loading">{{
          loading ? '' : '登录'
        }}</u-button>
        <div class="switchPsw" @click="switchType(1)">验证码登录</div>
        <div class="findPsw" @click="switchType(4)">找回密码</div>
      </div>
    </transition>
    <u-layer :visible="showlayer" cancel="知道了" @change="changeLayer">
      <h3 class="vtitle" slot="title">该手机号未绑定师生通</h3>
      <div class="vtips" slot="tips">请联系客服：0571-88930197</div>
    </u-layer>
  </div>
</template>
<script>
import { _getParames } from '@/utils/common';
import { hex_md5 } from '@/utils/md5';
import * as dingApi from '@/api/dingD';
import * as baseApi from '@/api/base';
import { json } from 'body-parser';
export default {
  name: 'login',
  data() {
    return {
      corpId: this.$store.state.global.corpId,
      ddcode: '', //钉钉临时授权码
      appCode: this.$store.state.global.appCode ? this.$store.state.global.appCode : sessionStorage.getItem('appCode'),
      school: this.$store.state.global.schoolCode,
      dingUserId: this.$store.state.global.dingUserId,
      typeLink: 1, //1：输入手机号  2：输入验证码
      inputvalue: '',
      inputpsw: '',
      loading: false,
      isGoSend: false, //是否可以登录
      isLogin: false,
      reguP: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      phone: '',
      boxList: Array(6),
      checkNum: '', //验证码
      countdown: 60, //倒计时
      timeLoop: null,
      isVerify: _getParames('verify'),
      showlayer: false,
    };
  },
  created() {
    localStorage.clear();
    this.$store.dispatch('setCorpId', this.corpId);
    this.$store.dispatch('setSchoolCode', this.school);
    this.$store.dispatch('setDingUserId', this.dingUserId);
    if (this.isVerify == 1) {
      this.typeLink = 3;
      this.inputvalue = this.$store.state.login.mobile;
    }
  },
  watch: {
    inputvalue(val) {
      let phoneNum = val.replace(/\s*/g, ''); //去除所有空格
      this.phone = phoneNum;
      this.isGoSend = false;
      this.isLogin = false;
      if (phoneNum.length === 11) this.isGoSend = true; //验证是否输满11位号码
      if (this.typeLink == 3 && this.isGoSend && this.inputpsw) {
        this.isLogin = true;
      }
    },
    inputpsw(val) {
      this.isLogin = false;
      if (this.typeLink == 3 && this.isGoSend && val) {
        this.isLogin = true;
      }
    },
    checkNum(val) {
      if (val.length == 6) {
        this.clickLogin();
      }
    },
  },
  methods: {
    goUrl(ind) {
      if (ind == 1) window.location.href = 'http://i.yd-jxt.com/apks/xieyi/index.html#/agreement?appType=3';
      if (ind == 2) window.location.href = 'http://i.yd-jxt.com/apks/xieyi/index.html#/privacy?appType=3';
    },
    focusCode() {
      this.$nextTick(() => {
        this.$refs.codeInput.handleFocus();
      });
    },
    async sendCode() {
      if (this.typeLink == 1) {
        this.phone = this.inputvalue.replace(/\s*/g, '');
        if (!this.reguP.test(this.phone)) {
          this.$UToast({
            content: '手机号码不正确',
            time: 1500,
          });
          return false;
        }
        this.$UToast({
          content: '验证手机号...',
          icon: 'load',
          time: 1500,
        });
      }
      if (this.typeLink == 2) {
        this.$UToast({
          content: '正在获取验证码...',
          icon: 'load',
          isClose: false,
        });
      }
      let data = {
        from: 'login',
        isSendMsg: 1, //是否要发送短信 1是 0 否 只校验手机是否合法（传0可验证电话号码是否有效，传1验证有效并发短信）
        tel: this.phone,
        school: this.school || this.$route.query.school,
        appsource: 1, //客户端开源 1：师生通
      };
      let res = await baseApi.sendCodeByMobile(data);
      // let res = await this.$axGet('SendVerificationCode',data)
      let thisNode = document.getElementsByClassName('tip-body')[0];
      if (thisNode) thisNode.parentNode.removeChild(thisNode);

      const { resultCode, resultMessage } = res;
      if (resultCode == 1) {
        this.typeLink = 2;
        this.countdown = 60;
        this.timer();
      } else if (resultCode == -3) {
        this.showlayer = true;
      } else if (resultCode == -100) {
        if (resultMessage == '短信验证码已下发，请耐心等待！') {
          this.$UToast({
            content: '短信验证码已下发<br>请耐心等待！',
            time: 1500,
          });
          this.typeLink = 2;
          this.countdown = 60;
          this.timer();
        } else
          this.$UToast({
            content: '获取过于频繁<br>请24小时后再试',
            time: 1500,
          });
      } else if (resultCode == -1) {
        if (resultMessage == '短信验证码已下发，请耐心等待！') {
          this.$UToast({
            content: '短信验证码已下发<br>请耐心等待！',
            time: 1500,
          });
          this.typeLink = 2;
          this.countdown = 60;
          this.timer();
        } else {
          this.$UToast({
            content: resultMessage,
            time: 1500,
          });
        }
      } else {
        this.$UToast({
          content: resultMessage,
          time: 1500,
        });
      }
    },
    async clickLogin() {
      let res = {};
      if (this.typeLink == 2) {
        let data = {
          mobile: this.phone,
          code: this.checkNum,
          school: this.school,
        };
        res = await baseApi.LoginByMobile(data);
      } else if (this.typeLink == 3) {
        let data = {
          username: this.phone,
          password: hex_md5(this.inputpsw),
          school: this.school,
        };
        this.loading = true;
        res = await baseApi.LoginByUserName(data);
        this.loading = false;
      }
      if (res.resultCode == 1) {
        let rolesList = res.value;
        // 绑定钉钉
        let bingData = {
          DingTalkUserId: this.dingUserId,
          SSTUserIds: rolesList.map(({ userId }) => userId).join(),
          school: this.school,
          corpId: this.corpId,
        };
        if (this.dingUserId && this.dingUserId != null && this.dingUserId != 'null') {
          let bindRes = await dingApi.bindDingTalkUserId(bingData);
        }

        this.$store.dispatch('setIsWelcome', true); //只有登录进入首页才会显示欢迎回来的提示语
        localStorage.setItem('rolesList', JSON.stringify(rolesList));
        localStorage.setItem('userId', rolesList[0].userId);
        this.$store.dispatch('setUserInfo', rolesList[0]);
        if (this.appCode) {
          this.toOtherPage(rolesList[0].userId);
        } else {
          this.$router.replace({ path: '/homeIndex' });
        }
      } else if (res.resultCode == -3) {
        this.showlayer = true;
      } else {
        this.checkNum = '';
        this.$UToast({
          content: res.resultMessage,
          time: 1500,
        });
      }
    },
    // 直接跳转到读书吧或者英语点读
    async toOtherPage(userId) {
      let isDD_env = this.$store.state.global.isDD_env;
      let isWx_env = this.$store.state.global.isWx_env;
      let platform = isWx_env ? 6 : isDD_env ? 5 : 0;
      let res = await baseApi.getAppAuthorityList({ school: this.school, userId: userId, platform: platform });
      if (res && res.resultCode == 1 && res.value && res.value.length > 0) {
        if (res.value.map((item) => item.code).indexOf(this.appCode) > -1) {
          let urls = res.value.filter((item) => item.code == this.appCode)[0].url;
          if (this.appCode == 'kldsb') {
            urls =
              'http://www.91118.com/activity/HappyReadingForDD/#/?duserid=' +
              this.dingUserId +
              '&FromType=7&corpId=' +
              this.corpId +
              '&userCode=' +
              userId;
            // urls = 'http://localhost:8730/#/?duserid=04251041432353&corpId=ding2f2292681ee1f840&fromType=6&userCode='+ userId
          }
          if (this.appCode == 'yydd') {
            urls =
              'http://www.91118.com/activity/englishreadingForDD/?duserid=' +
              this.dingUserId +
              '&corpId=' +
              this.corpId +
              '&fromtype=7&userCode=' +
              userId +
              '#/';
            // urls = 'http://localhost:8083/?duserid=04251041432353&corpId=ding2f2292681ee1f840&fromtype=7&userCode='+ userId +'#/'
          }
          window.location.href = urls;
        } else {
          this.$router.replace({ path: '/homeIndex' });
        }
      } else {
        this.$router.replace({ path: '/homeIndex' });
      }
    },
    switchType(type) {
      if (type == 4) {
        this.phone = this.inputvalue.replace(/\s*/g, '');
        this.$store.dispatch('setMobile', this.phone);
        this.$router.push({ path: '/updatePsw' });
        return false;
      }
      this.typeLink = type;
    },
    changeLayer() {
      this.showlayer = false;
      this.typeLink = 1;
      this.inputvalue = '';
      this.checkNum = '';
      this.inputpsw = '';
    },
    /* 计时器 */
    timer() {
      this.timeLoop = setInterval(() => {
        if (this.countdown > 0) this.countdown--;
        else clearInterval(this.timeLoop);
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.timeLoop);
  },
};
</script>
<style lang="scss" scoped></style>
